import Gdpr from "@/components/Gdpr"
import GdprBanner from "@/components/GdprBanner"

export default {
	components: {
		Gdpr,
		GdprBanner,
	},
	mounted(){
		this.$ga.load(this); // boot/wake google analytics on mount
	},
}